import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import UncollectedDebt from "../../../containers/modules/report/uncollected-debt";

export default function UncollectedDebtRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="uncollected-debt"
      index
      element={
        <AccessControl
          name={"Uncollected Debt Show"}
          auth={authUser}
          component={() => <UncollectedDebt />}
        />
      }
    ></Route>
  );
}
